import { useFlags } from "launchdarkly-react-client-sdk";
import { useContext } from "react";
import { useIntl } from "react-intl";
import { Link, NavLink } from "react-router-dom";
import { Button, Icon, Menu, Popup } from "semantic-ui-react";
import { checkIfWmx } from "../../../../libs/common_utils";
import { walmartMXTranslations } from "../../../../translations/walmartMXTranslations";
import { CREATIVE_TYPES } from "../../index/constants";
import CreativesGridContext from "../../index/context";

export const CreativesTabsMenu = ({ creativeType = "display" }) => {
  const context = useContext(CreativesGridContext);
  const {
    whitelabelBrandLiftCampaign,
    whitelabelChannelDisplay,
    whitelabelChannelVideo,
    whitelabelDoubleCreativeApproval,
  } = useFlags();
  const intl = useIntl();
  const isVideo = creativeType === "video";
  const isDisplay = creativeType === "display";
  const isBrandLift = creativeType === CREATIVE_TYPES.brandLift;

  /**
   * generate button title based on creative_type
   * @param {boolean} isVideo
   * @returns {string}
   */
  const getCreateButtonTitle = () => {
    return isVideo
      ? intl.formatMessage({
          defaultMessage: "Add Video Creative",
          id: "BTN_ADD_VIDEO_CREATIVE",
        })
      : intl.formatMessage({
          defaultMessage: "Add Display Creative",
          id: "BTN_ADD_DISPLAY_CREATIVE",
        });
  };

  return (
    <Menu
      pointing
      secondary
    >
      {whitelabelChannelDisplay && (
        <Menu.Item
          active={creativeType === "display"}
          as={NavLink}
          content={intl.formatMessage({
            defaultMessage: "Display",
            id: "LINK_DISPLAY",
          })}
          to="/creatives/display"
        />
      )}

      {whitelabelChannelVideo && (
        <Menu.Item
          active={creativeType === "video"}
          as={NavLink}
          content={intl.formatMessage({
            defaultMessage: "Video",
            id: "LINK_VIDEO",
          })}
          to="/creatives/video"
        />
      )}

      {whitelabelDoubleCreativeApproval && (
        <>
          <Menu.Item
            active={creativeType === CREATIVE_TYPES.onsite}
            as={NavLink}
            content={intl.formatMessage({
              defaultMessage: "On-Site Creatives",
              id: "LINK_ON_SITE_CREATIVES",
            })}
            to="/creatives/onsite"
          />

          <Menu.Item
            active={creativeType === CREATIVE_TYPES.instoreDOOH}
            as={NavLink}
            content={intl.formatMessage({
              defaultMessage: "In-store DOOH Creatives",
              id: "LINK_INSTORE_DOOH_CREATIVES",
            })}
            to="/creatives/in-store-dooh"
          />
        </>
      )}

      {whitelabelBrandLiftCampaign && (
        <Menu.Item
          active={creativeType === CREATIVE_TYPES.brandLift}
          as={NavLink}
          to="/creatives/brand-lift"
        >
          {intl.formatMessage({
            defaultMessage: "Brand Lift Creatives",
            id: "LINK_BRAND_LIFT_CREATIVES",
          })}
          {checkIfWmx() && (
            <Popup
              inverted
              content={walmartMXTranslations.brandLiftCreativesTabTooltip}
              size="mini"
              trigger={
                <Icon
                  name="help circle"
                  style={{ position: "relative", fontSize: "1rem", marginLeft: "6px" }}
                  className="cursor-help"
                />
              }
            />
          )}
        </Menu.Item>
      )}

      {(isVideo || isDisplay) && (
        <Menu.Menu position="right">
          <Menu.Item>
            <Button
              primary
              compact
              className="text__uppercase"
              onClick={() => context.navigateToCreatePage(isVideo)}
              content={getCreateButtonTitle(isVideo)}
            />
          </Menu.Item>
        </Menu.Menu>
      )}
      {isBrandLift && (
        <Menu.Menu position="right">
          <Menu.Item style={{ paddingLeft: "0.25rem", paddingRight: "0.25rem" }}>
            <Link
              className="ui primary button compact text__uppercase"
              to="/creative/brand-lift/create"
            >
              {intl.formatMessage({
                defaultMessage: "Add Brand Lift Display Creative",
                id: "BTN_ADD_BRAND_LIFT_DISPLAY_CREATIVE",
              })}
            </Link>
          </Menu.Item>
          <Menu.Item style={{ paddingLeft: "0.25rem", paddingRight: "0.25rem" }}>
            <Link
              className="ui primary button compact text__uppercase"
              to="/creative/brand-lift/video/create"
            >
              {intl.formatMessage({
                defaultMessage: "Add Brand Lift Video Creative",
                id: "BTN_ADD_BRAND_LIFT_VIDEO_CREATIVE",
              })}
            </Link>
          </Menu.Item>
        </Menu.Menu>
      )}
    </Menu>
  );
};

export default CreativesTabsMenu;
